import { Directive, ElementRef, effect, inject, input } from '@angular/core';
import { prefersReducedMotion } from '../services/reduced-motion';

const DURATION_MS = 200;

// Rise-in replayed on the host whenever the bound in-content tab key changes (AI-643) — put it
// on the persistent container of the content that follows the tab. Skips first render (the
// page's v3-card-in covers it) and reduced motion. WAAPI, not a CSS keyframe: cancel() +
// animate() restarts on a live element without a reflow hack.
@Directive({
  selector: '[appV3TabPanel]',
  standalone: true,
})
export class V3TabPanel {
  readonly key = input.required<unknown>({ alias: 'appV3TabPanel' });

  private readonly el = inject<ElementRef<HTMLElement>>(ElementRef);
  private animation: Animation | null = null;
  private mounted = false;

  constructor() {
    effect(() => {
      this.key();
      if (this.mounted) this.replay();
      this.mounted = true;
    });
  }

  private replay() {
    this.animation?.cancel();
    if (prefersReducedMotion()) return;
    this.animation = this.el.nativeElement.animate(
      [
        { opacity: 0, transform: 'translateY(6px)' },
        { opacity: 1, transform: 'none' },
      ],
      { duration: DURATION_MS, easing: 'ease-out' },
    );
  }
}
